import classNames from "classnames";
import { FetchError } from "components/molecules";
import image from "assets/Ellipse 155.png";
import { SelfPacedCourseworkDetailCard } from "components/molecules/SelfPacedCourseworkDetailCard";
import { Spinner } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  learningTracks: null | any;
  theme: "light" | "dark";
  isLoading?: boolean;
  isError?: boolean;
  isFetching?: boolean;
}

export const SelfPacedCourseworkDetailCardSection = ({
  learningTracks,
  theme,
  isLoading,
  isFetching,
  isError,
}: IProps) => {
  return (
    <div
      className={classNames(
        "self-paced-coursework-detail-card-section-wrapper"
      )}
    >
      {isLoading ? (
        <Spinner theme={theme} />
      ) : isError ? (
        <FetchError content="Oops! failed to load resources." />
      ) : learningTracks === null ? null : (
        Array.isArray(learningTracks) &&
        learningTracks.map((learningTrack: any, index: number) => (
          <SelfPacedCourseworkDetailCard
            key={index}
            borderColor={
              learningTrack.IsTestSegment
                ? "green"
                : learningTrack.IsTopicFocusSegment
                  ? "pink"
                  : "black"
            }
            isTabShow={true}
            title={learningTrack.LearningTrackName}
            groupNames={learningTrack.Groups?.map((group: any) => group.Name) || []}
            groups={learningTrack.Groups || []}
            theme={theme}
            itemPageNo={learningTrack.page}
          />
        ))
      )}
    </div>
  );
};
